import { SmsGroupTemplateType } from "@/models/club";
import smsTemplateService from "@/services/template";
import { useQuery } from "@tanstack/react-query";

function useGetSmsTemplates(smsGroupTemplateType: SmsGroupTemplateType) {
  const { data, isLoading, refetch } = useQuery(
    ["allSmsTemplate", smsGroupTemplateType],
    () => smsTemplateService.getAllSmsTemplate(smsGroupTemplateType)
  );

  return { data, isLoading, refetch };
}

export default useGetSmsTemplates;
